var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownClaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3232 2.04289C1.51847 1.84763 1.83505 1.84763 2.03031 2.04289L4.67676 4.68934L7.3232 2.04289C7.51847 1.84763 7.83505 1.84763 8.03031 2.04289C8.22557 2.23815 8.22557 2.55474 8.03031 2.75L4.67676 6.10355L1.3232 2.75C1.12794 2.55474 1.12794 2.23815 1.3232 2.04289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownClaret);
export default __webpack_public_path__ + "static/media/dropdown-claret.f663b1717c9ee7f8990585702c415e67.svg";
export { ForwardRef as ReactComponent };